import Layout from "components/Layout/Layout";
import { pca } from "lib/auth/pca";

const App = () => <Layout pca={pca} />;

export default App;
